import { render, staticRenderFns } from "./Falls.vue?vue&type=template&id=87d92844&"
import script from "./Falls.vue?vue&type=script&lang=js&"
export * from "./Falls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports